import { Box, Grid, Stack, Typography } from "@mui/material";

export const InstituteGrid = (props: {
  title?: string;
  content?: string;
  objective?: { caption: string; info: string }[];
  doubleObjective?: { caption: string; info: string }[];
  imageSrc?: string;
  inverted?: boolean;
}) => {
  return (
    <Grid
      container
      direction={{
        xs: "column-reverse",
        md: props.inverted ? "row-reverse" : "row",
      }}
      mb={8}
    >
      <Grid item xs={12} md={6}>
        <Stack
          justifyContent="center"
          alignItems="center"
          width={{ xs: "90%", md: "70%" }}
          mx="auto"
          height="100%"
          mt={{ xs: 3, md: 0 }}
        >
          <Box className=" md:w-[96%] lg:w-[491px] w-[300px] mx-auto md:ml-0 md:mr-0 md:text-start text-center">
            <Typography
              variant="h1"
              color="primary"
              fontSize={{ xs: "26px", sm: "32px" }}
              lineHeight={{ xs: "143%", sm: "120.5%" }}
              letterSpacing={"-0.04em"}
              className=" py-3"
            >
              {props.title}
            </Typography>
            <Typography
              variant="caption"
              color="primary"
              fontSize={{ xs: "12px", sm: "12px" }}
              lineHeight={{ xs: "185%", sm: "180%" }}
              letterSpacing={"0.02em"}
              className=" mt-6 uppercase "
            >
              {props.content}
            </Typography>
          </Box>
          {props.objective && (
            <Box
              color="primary"
              fontSize={{ xs: "13px", sm: "14px" }}
              lineHeight={{ xs: "185%", sm: "180%" }}
              letterSpacing={"0.02em"}
              className=" pb-10 mx-auto text-start mt-6"
            >
              {(props.objective || []).map((obj, index) => (
                <Box className="flex gap-2 py-2" key={index}>
                  •
                  <Typography
                    variant="body2"
                    color="primary"
                    fontSize={{ xs: "13px", sm: "14px" }}
                    lineHeight={{ xs: "185%", sm: "180%" }}
                    letterSpacing={"0.02em"}
                    className="text-start grid"
                  >
                    <b className="font-areaBlack">{obj.caption}</b> {obj.info}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
          {props.doubleObjective && (
            <Box
              color="primary"
              fontSize={{ xs: "13px", sm: "14px" }}
              lineHeight={{ xs: "185%", sm: "180%" }}
              letterSpacing={"0.02em"}
              className="md:w-[560px] w-[340px] pb-10 mx-auto text-start mt-6"
            >
              {(props.doubleObjective || []).map((obj, index) => (
                <Box key={index} className="py-2">
                  <Typography
                    variant="body2"
                    color="primary"
                    fontSize={{ xs: "13px", sm: "14px" }}
                    lineHeight={{ xs: "185%", sm: "180%" }}
                    letterSpacing={"0.02em"}
                    className="text-start font-areaBlack"
                  >
                    {obj.caption}
                  </Typography>
                  <Box className="grid gap-1 mt-1">
                    {obj.info.split("@@@@").map((item, idx) => (
                      <Typography
                        key={idx}
                        variant="body2"
                        color="primary"
                        fontSize={{ xs: "13px", sm: "14px" }}
                        lineHeight={{ xs: "185%", sm: "180%" }}
                        letterSpacing={"0.02em"}
                        className="text-start"
                      >
                        • {item.trim()}
                      </Typography>
                    ))}
                  </Box>
                </Box>
              ))}
            </Box>
          )}
        </Stack>
      </Grid>

      <Grid item xs={12} md={6}>
        <Box
          width={{ xs: "100%", md: "100%" }}
          mx="auto"
          sx={{
            "& img": {
              width: "100%",
              [props.inverted ? "pl" : "pr"]: { xs: 2, md: 10 },
              [props.inverted ? "pr" : "pl"]: 2,
            },
          }}
          className=""
        >
          <img
            src={props.imageSrc}
            alt={props.title}
            width="800"
            draggable={false}
            className=""
          />
        </Box>
      </Grid>
    </Grid>
  );
};
